import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import FolderZipOutlinedIcon from "@mui/icons-material/FolderZipOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import SendIcon from "@mui/icons-material/Send";
import { Box, Grid, styled } from "@mui/material";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import "cropperjs/dist/cropper.css";
import React, { createRef, useEffect, useState } from "react";
import Cropper, { ReactCropperElement } from "react-cropper";
import { Mention, MentionsInput } from "react-mentions";
import { fileType } from "../../components/drawers/attachmentDrawer";

import { useMutation } from "react-query";
import { SendMessage } from "../../services/chat.service";

import { Document, Page, pdfjs } from "react-pdf";

import PhotoCameraBackOutlinedIcon from "@mui/icons-material/PhotoCameraBackOutlined";
import { toast } from "react-toastify";
import { v4 } from "uuid";
import { DocumentUrl } from "../../models/cartable.model";
import { SendMessageRequest } from "../../models/chat.model";
import SettingsBackupRestoreOutlinedIcon from "@mui/icons-material/SettingsBackupRestoreOutlined";
import CropOutlinedIcon from "@mui/icons-material/CropOutlined";

import {} from "../../../person_3_black_24dp.svg";

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

interface Props {
  attachmentCaptionDrawer: boolean;
  setAttachmentCaptionDrawer: (attachmentDrawer: boolean) => any;
  choosedImgSrc: any;
  setChoosedImgSrc: any;
  setChoosedFileSrc: any;
  choosedFileSrc: any;
  isFile: fileType;
  isEditBtnDisable: boolean;
  setEditBtnDisable: (isEditBtnDisable: boolean) => any;
  referenceKey: string;
  mentionUsers: any;

  setAttachmentDrawer: any;
  setRefreshOnSendCap: any;
  funcRefImage: any;
  funcRefFile: any;
  refDropZoneImage: any;
  refDropZoneFile: any;
  choosedImgCropperSrc: any;
  setChoosedImgCropperSrc: any;
}
const AttachmentCaptionDrawer = ({
  setAttachmentCaptionDrawer,
  attachmentCaptionDrawer,
  choosedImgSrc,
  setChoosedImgSrc,
  choosedFileSrc,
  setChoosedFileSrc,
  isFile,
  isEditBtnDisable,
  setEditBtnDisable,
  referenceKey,
  mentionUsers,

  setAttachmentDrawer,
  setRefreshOnSendCap,
  funcRefImage,
  funcRefFile,
  refDropZoneImage,
  refDropZoneFile,
  choosedImgCropperSrc,
  setChoosedImgCropperSrc,
}: Props) => {
  // let m = choosedImgSrc[0]?.preview;
  const cropperRef = createRef<ReactCropperElement>();
  const [comment, setComment] = useState("");
  const [rotate, setRotate] = useState(0);
  const [numPages, setNumPages] = useState<number>();
  const [pageNumber, setPageNumber] = useState<number>(1);
  // const [mentionedUserIds, setMentionedUserIds] = useState<number[]>([]);
  const [files, setFiles] = useState<string[]>([]);
  const [test12, setTest12] = useState<any>();
  const mentionPattern = /\@(.*?)\)/gi;
  useEffect(() => {
    // setTest12(choosedImgSrc[0].preview);
  }, []);
  // let kkk = choosedImgSrc[0].preview
  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(numPages);
  }

  const getCropData = () => {
    if (typeof cropperRef.current?.cropper !== "undefined") {
      setTest12(cropperRef.current?.baseURI);
      // let m = {
      //   preview: cropperRef.current?.baseURI,
      //   preview: cropperRef.current?.cropper.getCroppedCanvas().toDataURL(),
      // };

      setChoosedImgCropperSrc(
        cropperRef.current?.cropper.getCroppedCanvas().toDataURL()
      );
    }
  };

  const { mutate: SendMessageMutation } = useMutation(SendMessage, {
    onSuccess: (data: boolean) => {
      setRefreshOnSendCap(v4());
      setChoosedImgSrc("");
      setChoosedFileSrc([]);
      setRotate(0);
      setComment("");
    },
    onError: () => {},
  });

  const handleSendMessage = () => {
    const newMessage = {} as SendMessageRequest;
    if (mentionPattern.test(comment)) {
      let desiredText = comment.replace(mentionPattern, "");
      let mentionedIds;
      let mentioned: any = [];
      const mentionedSet = new Set();
      let mentionedUserIds: any = [];

      while ((mentionedIds = mentionPattern.exec(comment)) !== null) {
        mentioned.push(mentionedIds[0]);
      }

      mentioned.map((item: any) => {
        mentionedSet.add(Number(item.split("(")[1].split("/")[0]));
      });

      mentionedSet.forEach((value, valueAgain, set) => {
        mentionedUserIds.push(value);
      });
      if (mentionedUserIds) {
        newMessage.mentionedUserIds = mentionedUserIds;
      }
      if (desiredText === "") {
        desiredText = " ";
      }
      newMessage.messageText = desiredText;
    } else {
      newMessage.messageText = comment;
    }

    newMessage.referrerMessageKey = "";
    newMessage.referenceKey = referenceKey;

    const attachFile = {} as DocumentUrl;
    isFile === "image"
      ? (attachFile.fileUrl = choosedImgSrc[0].preview)
      : (attachFile.fileUrl = choosedFileSrc[0].preview);

    if (isFile === "image") {
      if (choosedImgSrc) {
        if (
          choosedImgSrc[0].size !== null &&
          choosedImgSrc[0].size / 1_000_000 > 3
        ) {
          toast.error("امکان ارسال عکس بیشتر از ۳ مگابایت وجود ندارد.");
          return;
        }
      }
    } else {
      if (choosedFileSrc) {
        if (
          choosedFileSrc[0].size !== null &&
          choosedFileSrc[0].size / 1_000_000 > 10
        ) {
          toast.error("امکان ارسال فایل بیشتر از ۱۰ مگابایت وجود ندارد.");
          return;
        }
      }
    }

    newMessage.files = isFile === "image" ? choosedImgSrc : choosedFileSrc;

    SendMessageMutation(newMessage);
    setComment("");
    setAttachmentCaptionDrawer(false);
    setAttachmentDrawer(false);
  };

  // pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  //   "pdfjs-dist/build/pdf.worker.min.js",
  //   import.meta.url
  // ).toString();
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  return (
    <>
      {attachmentCaptionDrawer ? (
        <div className="comment-chat-caption">
          <Card
            sx={{
              width: "100%",
              height: "100%",
              background: "#00102e !important",
              color: "#fff !important",
              border: "none",
            }}
          >
            <Grid
              container
              justifyContent={"space-around"}
              alignItems={"center"}
              padding={"10px"}
              // height={"100%"}
            >
              <Grid item xs={4}>
                {/* <Grid container>
                  <Grid
                    item
                    xs={3}
                    onClick={() => {
                      // debugger;
                      setRotate(rotate - 90);
                    }}
                    className={choosedImgSrc === "" ? "disableForm" : ""}
                    sx={{ cursor: "pointer" }}
                  >
                    {isFile === "image" ? (
                      <SettingsBackupRestoreOutlinedIcon />
                    ) : null}
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    onClick={getCropData}
                    sx={{ cursor: "pointer" }}
                    className={choosedImgSrc === "" ? "disableForm" : ""}
                  >
                    {isFile === "image" ? <CropOutlinedIcon /> : null}
                  </Grid>
                </Grid> */}
              </Grid>

              <Grid xs={6}></Grid>
              <Grid
                item
                sx={{ textAlign: "left", cursor: "pointer" }}
                xs={2}
                onClick={() => {
                  // setAttachmentCaptionDrawer(false);
                  setChoosedImgSrc("");
                  setChoosedFileSrc([]);
                  setRotate(0);
                  setComment("");
                  setAttachmentCaptionDrawer(false);
                  setAttachmentDrawer(false);
                }}
              >
                <CloseOutlinedIcon />
              </Grid>
            </Grid>
            {isFile === "image" ? (
              choosedImgSrc ? (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    minHeight: "350px",
                    justifyContent: "center",
                  }}
                >
                  <Cropper
                    ref={cropperRef}
                    style={{ height: 400, width: "100%" }}
                    zoomTo={0.4}
                    initialAspectRatio={1}
                    preview=".img-preview"
                    src={choosedImgCropperSrc}
                    // src="https://raw.githubusercontent.com/roadmanfong/react-cropper/master/example/img/child.jpg"
                    viewMode={1}
                    minCropBoxHeight={10}
                    minCropBoxWidth={10}
                    background={true}
                    responsive={true}
                    autoCropArea={1}
                    checkOrientation={false}
                    guides={true}
                    rotatable={true}
                    rotateTo={rotate}
                  />
                </div>
              ) : (
                <Box sx={{ cursor: "pointer", textAlign: "center" }}>
                  <Grid
                    container
                    direction={"column"}
                    gap={"0.5rem"}
                    height={"250px"}
                    justifyContent={"center"}
                    alignItems={"center"}
                  >
                    <Grid
                      item
                      sx={{
                        // borderRadius: "50%",

                        height: "70px",
                        width: "70px",
                        padding: "1rem",
                      }}
                      onClick={() => {
                        funcRefImage(refDropZoneImage);
                      }}
                    >
                      <PhotoCameraBackOutlinedIcon
                        sx={{ color: "#fff", width: "100%", height: "100%" }}
                      />
                    </Grid>
                    <Grid item sx={{ color: "#fff" }}>
                      بارگذاری عکس
                    </Grid>
                  </Grid>
                </Box>
              )
            ) : isFile === "file" && choosedFileSrc.length > 0 ? (
              [...choosedFileSrc].map((file: any) => (
                <>
                  {/* <a href={file.preview} target="_blank">
                    <PictureAsPdfOutlinedIcon
                      className={"uploadImageCmpIconPDF"}
                      // style={{ marginTop: "1vh" }}
                    />
                  </a> */}
                  {file.type.includes("pdf") ? (
                    <div
                      style={{
                        minHeight: "350px",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <a href={file.preview} target="_blank">
                        <Document
                          file={file.preview}
                          onLoadSuccess={onDocumentLoadSuccess}
                          loading={
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "300px",
                                height: "350px",
                              }}
                            >
                              <p>در حال بارگذاری...</p>
                            </div>
                          }
                          error={
                            <>
                              efwiewhiuye
                              <PictureAsPdfOutlinedIcon
                                className={"uploadImageCmpIconPDF"}
                                // style={{ marginTop: "1vh" }}
                              />
                            </>
                          }
                        >
                          <Page pageNumber={pageNumber} />
                        </Document>
                      </a>
                      {/* <p>
                      Page {pageNumber} of {numPages}
                    </p> */}
                    </div>
                  ) : file.type.includes("zip") ? (
                    <div
                      style={{
                        minHeight: "250px",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <a href={file.fileUrl} target="_blank">
                        <FolderZipOutlinedIcon
                          className={"uploadImageCmpIconPDF"}
                          // style={{ marginTop: "1vh" }}
                        />
                      </a>
                    </div>
                  ) : (
                    <div
                      style={{
                        minHeight: "250px",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <a href={file.fileUrl} target="_blank">
                        <InsertDriveFileOutlinedIcon
                          className={"uploadImageCmpIconPDF"}
                          // style={{ marginTop: "1vh" }}
                        />
                      </a>
                    </div>
                  )}
                </>
              ))
            ) : (
              <Box
                onClick={() => {
                  // fileRef.current.click();
                }}
                sx={{ cursor: "pointer", textAlign: "center" }}
              >
                <Grid
                  container
                  direction={"column"}
                  gap={"0.5rem"}
                  height={"250px"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Grid
                    item
                    sx={{
                      // borderRadius: "50%",

                      height: "70px",
                      width: "70px",
                      padding: "1rem",
                    }}
                    onClick={() => {
                      funcRefFile(refDropZoneFile);
                    }}
                  >
                    <PhotoCameraBackOutlinedIcon
                      sx={{ color: "#fff", width: "100%", height: "100%" }}
                    />
                  </Grid>
                  <Grid item sx={{ color: "#fff" }}>
                    بارگذاری فایل
                  </Grid>
                </Grid>
              </Box>
            )}
            <CardActions disableSpacing>
              <Grid container alignItems={"center"} columns={14}>
                <Grid item xs={12} width={"100%"} height={"100%"}>
                  <MentionsInput
                    style={{
                      background: "#fff",
                      width: "100%",
                      height: "50px",
                      border: "none",
                      // overflowY: "auto",
                      borderRadius: "0px 5px 5px 0px",
                    }}
                    value={comment}
                    onChange={(event) => setComment(event.target.value)}
                    // className="mentions image-mention"
                    className={
                      isFile === "image"
                        ? !choosedImgSrc
                          ? "mentions image-mention disableForm"
                          : "mentions image-mention"
                        : choosedFileSrc.length === 0
                        ? "mentions image-mention disableForm"
                        : "mentions image-mention"
                    }
                    placeholder="متن پیگیری ..."
                    allowSuggestionsAboveCursor={true}
                  >
                    <Mention
                      appendSpaceOnAdd
                      className="mentionedUsers"
                      data={mentionUsers}
                      trigger="@"
                      style={{ color: "black !important" }}
                      displayTransform={(id, display) => `@ ${display}`}
                      renderSuggestion={(
                        suggestion,
                        search,
                        highlightedDisplay,
                        index,
                        focused
                      ) => (
                        <div>
                          {suggestion.id.toString().search(/female/i) !== -1 ? (
                            <img
                              src="/images/person_3_black_24dp.svg"
                              alt="avatar"
                              className="mentions-avatar"
                            />
                          ) : (
                            <img
                              src="/images/person_black_24dp.svg"
                              alt="avatar"
                              className="mentions-avatar"
                            />
                          )}
                          {highlightedDisplay}
                        </div>
                      )}
                      // onAdd={(e) =>
                      //   typeof e === "string"
                      //     ? setMentionedUserIds([
                      //         ...mentionedUserIds,
                      //         Number(e.split("/")[0]),
                      //       ])
                      //     : null
                      // }
                    />
                  </MentionsInput>
                </Grid>

                <Grid
                  item
                  xs={2}
                  width={"100%"}
                  height={"100%"}
                  sx={{
                    cursor: "pointer",
                    background:
                      choosedImgSrc === "" && choosedFileSrc.length === 0
                        ? "#7fd7a0"
                        : "#28A745",
                    textAlign: "center",
                    borderRadius: "5px 0px 0px 5px",
                  }}
                  onClick={handleSendMessage}
                  className={
                    choosedImgSrc === "" && choosedFileSrc.length === 0
                      ? "disableForm"
                      : ""
                  }
                >
                  <SendIcon
                    style={{ rotate: "180deg", height: "50px" }}
                    fontSize="large"
                  />
                </Grid>
              </Grid>
            </CardActions>
          </Card>
        </div>
      ) : null}
    </>
  );
};
export default AttachmentCaptionDrawer;
